import React from 'react';
import type { ProductPriceToDisplayProps } from 'common/components/product-card/types';
import { useProductPrice } from 'common/components/product-card/use-product-price';
import { PriceBlock } from 'fronton-react';
import { useBreakpoints } from 'common/hooks';

export const BrandShelfProductPriceToDisplay: React.FC<ProductPriceToDisplayProps> = ({
  hasOldPrice,
  price,
  productPriceCategory,
}) => {
  const { mobile } = useBreakpoints() || { mobile: false };

  const { mainPrice, units, discount, unitUnits, type } = useProductPrice({
    hasOldPrice,
    price,
    productPriceCategory,
  });

  return (
    <div>
      <PriceBlock
        price={mainPrice}
        units={units}
        unitUnits={unitUnits}
        discount={discount}
        oldPrice={price.previous_price ?? undefined}
        type={type}
        size={mobile ? 'm' : 'l'}
        direction="vertical"
      />
    </div>
  );
};
